import React from 'react';
import styles from './socialProofing.module.css';
import { getTextStyles } from '../../../utils/textStyleUtils';

interface SocialProofingProps {
  text: {
    parent: {
      text: string;
      style?: {
        textStyle?: string;
        textColor?: string;
      };
    };
    placeholder: {
      texts: string[];
      style?: {
        textStyle?: string;
        textGradientColors?: string;
      };
    };
  };
  bgGradientColors?: string;
}

const SocialProofing: React.FC<SocialProofingProps> = ({
  text,
  bgGradientColors = '#0D0E11,#2D1B00,#0D0E11',
}) => {
  // Parse the parent text to find placeholder
  const parentText = text.parent.text;
  const placeholderText = text.placeholder.texts[0] || '';
  
  // Replace %s with placeholder text
  const formattedText = parentText.replace('%s', placeholderText);
  const parts = formattedText.split(placeholderText);

  const gradientColors = bgGradientColors.split(',').map(c => c.trim());

  return (
    <div
      className={styles.socialProofing}
      style={{
        background: `linear-gradient(180deg, ${gradientColors.join(', ')})`,
      }}
    >
      <div className={styles.textContainer}>
        {parts[0] && (
          <span
            className={styles.parentText}
            style={getTextStyles(text.parent.style)}
          >
            {parts[0]}
          </span>
        )}
        {placeholderText && (
          <span
            className={styles.placeholderText}
            style={getTextStyles(text.placeholder.style)}
          >
            {placeholderText}
          </span>
        )}
        {parts[1] && (
          <span
            className={styles.parentText}
            style={getTextStyles(text.parent.style)}
          >
            {parts[1]}
          </span>
        )}
      </div>
    </div>
  );
};

export default SocialProofing;

